import { useNavigate } from 'react-router-dom'
import * as React from 'react';
import {Box, IconButton} from '@mui/material';
import CallMissedIcon from '@mui/icons-material/CallMissed';
import Typography from '@mui/material/Typography';

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <Box sx={{ '& > :not(style)': { m: 1 } }} textAlign='center'>
            <Typography variant="h4" gutterBottom style={{marginTop: '5%', color: '#b2b2b2'}}>
                404. Page not found.
            </Typography>
            <IconButton variant="outlined"
                        color="primary"
                        aria-label="add to shopping cart"
                        style={{marginTop: '2%', marginBottom: '5%'}}
                        onClick={() => {navigate(-1)}}

            >
                <CallMissedIcon/> Go back
            </IconButton>
        </Box>
    );
}